import { restApi } from 'src/redux/api/rest/restApi'
import type {
	ReduxComments,
	ReduxCompany,
	ReduxQuote,
	ReduxQuoteInfo,
	ReduxSectionRename,
} from 'src/types/apiType'

export const quoteRestApi = restApi.injectEndpoints({
	endpoints: (builder) => ({
		fetchRestQuoteById: builder.query({
			query: (id: string) => ({
				apiName: 'restApiChedar',
				method: 'GET',
				path: `/public/quote/${id}`,
			}),
			transformResponse: ({
				result: {
					quote,
					quoteInfo,
					commentsArray,
					companyInfo,
					companyLogoUrl,
					tAndCArray,
					sectionRenameDict,
				},
			}: {
				result: {
					quote: ReduxQuote
					quoteInfo: ReduxQuoteInfo[]
					commentsArray: ReduxComments[]
					companyInfo: ReduxCompany
					companyLogoUrl: string
					tAndCArray: string[]
					sectionRenameDict: Record<string, ReduxSectionRename>
				}
			}) => {
				return {
					quote,
					quoteInfo,
					commentsArray,
					companyInfo,
					companyLogoUrl,
					tAndCArray,
					sectionRenameDict,
				}
			},
			providesTags: (result, error, id) => [{ type: 'PublicQuote', id }],
		}),
	}),
	overrideExisting: false,
})

export const { useFetchRestQuoteByIdQuery } = quoteRestApi
